import { useEffect, useState } from 'react';
import { IconButton, Snackbar } from '@mui/material';
import { RefreshOutlined } from '@mui/icons-material';
import * as api from '../lib/api';

const FIVE_MINUTES = 5 * 60 * 1000;
const CURRENT_UI_VERSION = import.meta.env.VITE_UI_VERSION || 'local';

export function VersionChecker(props) {
  const { interval = FIVE_MINUTES } = props;
  const [showRefresh, setShowRefresh] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      api.getCurrentVersion().then((currentServerVersion) => {
        setShowRefresh(currentServerVersion !== CURRENT_UI_VERSION);
        if (CURRENT_UI_VERSION === 'local') clearInterval(intervalId);
      });
    }, interval);

    return () => clearInterval(intervalId);
  }, [interval]);

  return (
    <>
      <Snackbar
        open={showRefresh}
        message="A new version of TFS is now available. Please refresh your browser to get the changes."
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{
          '& .MuiSnackbarContent-root': {
            background: 'white',
            borderTop: (theme) => `4px solid ${theme.palette.primary.main}`,
          },
          '& .MuiSnackbarContent-message': {
            color: (theme) => theme.palette.text.primary,
          },
        }}
        action={
          <IconButton
            data-testid="refresh-app"
            onClick={() => window.location.reload()}
          >
            <RefreshOutlined color="success" />
          </IconButton>
        }
      />
      {props.children}
    </>
  );
}
